var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPrice)?_c('button',{staticClass:"prodcard__addtocart",attrs:{"title":"Добавить в корзину"},on:{"click":_vm.addToCart}},[_c('img',{attrs:{"src":_vm.url + '/assets/img/ico-cartprod.svg',"alt":""}})]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51c89f57","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./themes/polza/src/js/components/commerce/lent-prod.vue
// module id = 36
// module chunks = 0